const dataTables = ["Grupo", "Variavel"];

function genState () {
	const obj = {};
	for (const dataTable of dataTables) {
		obj["dataTable" + dataTable] = {
			//TODO REFATORAR SORT
			sortBy: 10,
			sortAsc: false,
			query: ""
		};
	}
	return obj;
}

function genMutations () {
	const obj = {};
	for (const dataTable of dataTables) {
		obj["setStateDataTable" + dataTable] = function setStateDataTable (state, sort) {
			state["dataTable" + dataTable] = sort;
		};
	}
	return obj;
}

export default {
	namespaced: true,
	state: genState(),
	mutations: genMutations()
};
